import { NgModule } from "@angular/core";
import { SharedModule } from "lib-trend-core";
import { LeadSourceComponent } from "./lead-source.component";
import { ModalLeadSourceComponent } from './modal-lead-source/modal-lead-source.component';

@NgModule({
  imports: [SharedModule],
  declarations: [LeadSourceComponent, ModalLeadSourceComponent],
  exports: [LeadSourceComponent],
})

export class LeadSourceModule { }
